import { render, staticRenderFns } from "./resultLogicForm.vue?vue&type=template&id=472c936b&scoped=true&"
import script from "./resultLogicForm.vue?vue&type=script&lang=js&"
export * from "./resultLogicForm.vue?vue&type=script&lang=js&"
import style0 from "./resultLogicForm.vue?vue&type=style&index=0&id=472c936b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c936b",
  null
  
)

export default component.exports